<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Imagens Conteúdo - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'contentphotos'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-content-photo :btnLabel="btnLabel" :content_id="content_id"></form-content-photo>
</span>
</template>

<script>
import FormContentPhotoComponent from "./partial/FormContentPhotoComponent";

export default {
    name: "AddContentPhotoComponent",
    created() {

    },
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    props: {
        cont_ft_id: {
            require: true
        },
        content_id: {
            require: true
        }
    },
    methods: {

    },
    components: {
        formContentPhoto: FormContentPhotoComponent,
    }
};
</script>

<style scoped>

</style>
